import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { getCartWishlistCounts } from '../../../actions/homeData';
import { getCartCount } from '../../selectors/counter';
import Icon from '../../atoms/Icon';
import { getCurrentStore } from '../../selectors/metaData';
import { getLuxeFlags } from '../../../Flags/selectors';

const mapStateToProps = (state: import('../../types/rootState').RootState): CartIconProps => ({
  cartCount: getCartCount(state),
  currentStore: getCurrentStore(state),
  luxeFlags: getLuxeFlags(state.flags)
});

const iconStyle = (sisIconColor: string): Record<string, string> =>
  Object.freeze({
    fontSize: '2.8rem',
    color: sisIconColor || '#202020'
  });

const luxeIconStyle = (): Record<string, string> =>
  Object.freeze({
    fontSize: '24px'
  });

const mapDispatchToProps = {
  getCartWishlistCounts
};

const connector = connect(mapStateToProps, mapDispatchToProps);

interface CartIconProps {
  cartCount?: number;
  getCartWishlistCounts: () => void;
  sisIconColor: string;
  currentStore: string;
  luxeFlags: LuxeFlags;
}
interface LuxeFlags {
  isThemeEnable: string;
}

const CartIcon: FC<CartIconProps> = (props: CartIconProps) => {
  const {
    cartCount = 1,
    getCartWishlistCounts,
    sisIconColor,
    id = '',
    currentStore,
    luxeFlags
  } = props;
  const { isThemeEnable } = luxeFlags;

  useEffect(() => {
    getCartWishlistCounts();
  }, [getCartWishlistCounts]);

  return isThemeEnable === 'ON' && currentStore === 'luxe' ? (
    <Icon role='link' icon="luxe-Bag" ariaLabel={`Cart with ${cartCount} item${cartCount === 1 ? '' : 's'}`} styles={luxeIconStyle()} count={cartCount} id={id} />
  ) : (
    <Icon role='link' icon="icon-Bag" ariaLabel={`Cart with ${cartCount} item${cartCount === 1 ? '' : 's'}`} styles={iconStyle(sisIconColor)} count={cartCount} id={id} />
  );
};

CartIcon.defaultProps = {
  cartCount: 0
};

export default connector(CartIcon);
